<template>
  <div>
    <div class="membership-tiers-body">
      <b-row>
        <b-col md="2" class="mb-3 mb-md-0">
          <div class="filter-wrapper">
            <b-form-select
              v-model="selectedFilter"
              :options="filterOptions"
              @input="setParam"
            ></b-form-select>
          </div>
        </b-col>
        <b-col md="4">
          <div class="filter-wrapper">
            <b-input-group append=" ">
              <b-input placeholder="Search" v-model="searchKey" @input="setParam"></b-input>
            </b-input-group>
          </div>
        </b-col>
        <b-col md="2" class="ml-auto text-right">
          <b-button
            variant="primary"
            class="form-control new-button align-top mr-3"
             @click="showAddMemberTiersModal"
            >+ New Tier</b-button
          >
        </b-col>
      </b-row>
      <template v-if="tierList.length > 0">
        <b-row class="my-4">
          <b-col
            v-for="(tier, index) in tierList"
            v-bind:key="index"
            md="3"
            class="mb-3 rounded"
            @mouseleave="$root.$emit('bv::hide::popover')"
          >
            <b-container class="tier-container p-2">
              <b-row no-gutters class="pt-2">
                <b-col>
                  <div style="height: 26px">
                    <switches
                      v-model="tier.is_published"
                      theme="custom"
                      color="primary"
                      type-bold="true"
                      text-enabled="On"
                      text-disabled="Off"
                      style="top: -20px"
                      :emit-on-mount="false"
                      @input="toggleTier(tier)"
                    ></switches>
                  </div>
                </b-col>
                <b-col
                  :id="`ellipsis-action-${index}`"
                  class="text-right align-middle"
                >
                  <img
                    :id="`popover-${index}`"
                    src="@/assets/images/icons/ellipsis-vertical.svg"
                    alt="Ellipsis Icon"
                    class="cursor-pointer"
                  />
                  <b-popover
                    :target="'popover-' + index"
                    triggers="click focus"
                    placement="bottomright"
                    class="px-0"
                    :container="`ellipsis-action-${index}`"
                  >
                    <div 
                      class="tier-action cursor-pointer pl-2 pr-5 py-2" 
                      @click="getTier(tier.uuid, 'edit-membership-tier-modal')"
                    >
                      Edit
                    </div>
                    <div 
                      class="tier-action cursor-pointer pl-2 pr-5 py-2"
                      @click="deleteTier(tier.uuid)"
                    >
                      Delete
                    </div>
                  </b-popover>
                </b-col>
              </b-row>
              <b-row no-gutters class="mt-2">
                <b-col class="text-center">
                  <b-img
                    :src="tier.badge_image_url"
                    class="bg-white px-2 py-3 tier-logo"
                    rounded="circle"
                    alt="Logo"
                    fluid
                  />
                </b-col>
              </b-row>
              <b-row no-gutters class="mt-2">
                <b-col>
                  <div class="tier-card text-center pb-3">
                    <div class="tier-name text-truncate mb-2">{{ tier.name }}</div>
                    <div class="tier-description mb-1">
                      {{ tier.description | rawText }}
                    </div>
                    <p class="tier-points">
                      <span class="font-weight-bold">{{
                        tier.points_requirement
                      }}</span>
                      Point{{ tier.points_requirement > 1 ? 's' : ''}}
                    </p>
                    <b-button
                      variant="primary"
                      class="action-button"
                      block
                      :to="{
                        name: 'membershipTiersMembers',
                        params: { uuid: tier.uuid },
                      }"
                    >
                      View Members
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <h2 class="text-center mt-5">No Results Found</h2>
      </template>
      <!-- MODAL START -->
      <AddMembershipTierModal ref="addMembershipTierModal" />
      <EditMembershipTierModal />
      <UploadBadgeModal :previous-modal="previousModal"  />
      <ConfirmationModal ref="confirmationModal" @click:confirm="confirmDelete"/>
      <!-- MODAL END -->
    </div>
  </div>
</template>

<script>
import Switches from "vue-switches";
import { mapState, mapActions } from "vuex";
import AddMembershipTierModal from "./membership-tier/AddMembershipTierModal";
import EditMembershipTierModal from "./membership-tier/EditMembershipTierModal";
import UploadBadgeModal from "./membership-tier/UploadBadgeModal";
import ConfirmationModal from "@/components/membership-tiers/confirmation";

export default {
    name: "MembershipTiers",
    data() {
        return {
            selectedFilter: "active",
            filterOptions: [
                { value: "active", text: "Active in App" },
                { value: "inactive", text: "Inactive in App" }
            ],
            searchKey: "",
            previousModal: "",
            param: {
                filters: {
                    keyword: "",
                    column: "active"
                }
            }
        };
    },
    components: {
        Switches,
        AddMembershipTierModal,
        EditMembershipTierModal,
        UploadBadgeModal,
        ConfirmationModal
    },
    computed: {
        ...mapState("programMembershipTiers", ["tierList", "badge"])
    },
    created() {
        this.getTierList(this.param);
    },
    filters: {
        rawText(text) {
            return text.replace(/<[^>]*>?/gm, "").trim();
        }
    },
    methods: {
        ...mapActions("programMembershipTiers", ["getTierList"]),
        showAddMemberTiersModal() {
            this.previousModal = "add-membership-tier-modal";
            this.$refs.addMembershipTierModal.init();
            this.$root.$emit("bv::show::modal", "add-membership-tier-modal");
        },
        toggleTier: async function(tier) {
            let param = {
                id: tier.uuid,
                payload: {
                    published: tier.is_published
                }
            };

            await this.$store.dispatch(
                "programMembershipTiers/publishTier",
                param
            );
        },
        getTier: async function(id, previousModal) {
            this.previousModal = previousModal;
            let _this = this;
            await this.$store
                .dispatch("programMembershipTiers/getTier", id)
                .then(function() {
                    _this.$root.$emit(
                        "bv::show::modal",
                        "edit-membership-tier-modal"
                    );
                });
        },
        deleteTier: async function(id) {
            this.$refs.confirmationModal.tier = this.tierList.find(
                el => el.uuid === id
            );

            this.$root.$emit(
                "bv::show::modal",
                "membership-tiers-confirmation-modal"
            );
        },
        async confirmDelete(id) {
            let _this = this;

            await this.$store
                .dispatch("programMembershipTiers/deleteTier", id)
                .then(function() {
                    _this.getTierList();
                    _this.$root.$emit("bv::hide::popover");
                });

            this.$root.$emit(
                "bv::hide::modal",
                "membership-tiers-confirmation-modal"
            );
        },
        setParam: function() {
            this.param = {
                filters: {
                    keyword: this.searchKey,
                    column: this.selectedFilter
                }
            };

            this.getTierList(this.param);
        }
    }
};
</script>
<style lang="scss">
</style>
